import { render, staticRenderFns } from "./TrainingModuleTaskData.vue?vue&type=template&id=412ce30c&scoped=true&"
import script from "./TrainingModuleTaskData.vue?vue&type=script&lang=js&"
export * from "./TrainingModuleTaskData.vue?vue&type=script&lang=js&"
import style0 from "./TrainingModuleTaskData.vue?vue&type=style&index=0&id=412ce30c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412ce30c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VFlex,VLayout,VPagination,VRadio,VRadioGroup,VStepper,VStepperContent,VStepperItems,VTextField})
